import { render } from "./BusinessDirectories.vue?vue&type=template&id=548b4773"
import script from "./BusinessDirectories.vue?vue&type=script&lang=js"
export * from "./BusinessDirectories.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__